import { create } from "zustand";

const useAttachmentsStore = create((set) => ({
  attachments: [],

  addAttachment: (attachment) =>
    set((state) => ({
      attachments: [...state.attachments, attachment], 
    })),

  clearAttachments: () =>
    set({
      attachments: [],
    }),
}));

export default useAttachmentsStore;